<script>
    import {FormFeedback, Input, InputGroup, InputGroupText} from "@sveltestrap/sveltestrap";
    import Fa from "svelte-fa";
    import {faEye, faEyeSlash} from "@fortawesome/free-solid-svg-icons";

    /**
     * @typedef {Object} Props
     * @property {any} pw
     * @property {string} [showPwLabel]
     * @property {string} [hidePwLabel]
     * @property {string} [formFeedback]
     */

    /** @type {Props & { [key: string]: any }} */
    let {
        pw = $bindable(),
        showPwLabel = 'Passwort anzeigen',
        hidePwLabel = 'Passwort verbergen',
        formFeedback = 'Falsches Passwort.',
        ...rest
    } = $props();

    let type = $state('password');
    let plaintext = $state(false);
    let container = $state();

    function togglePwReveal() {
        plaintext = !plaintext;
        type = plaintext ? 'text' : 'password';
        setTimeout(() => {
            container?.querySelector('input')?.focus();
        }, 100);
    }
</script>

<div bind:this={container}>
    <InputGroup class="input-password">
        <Input {...{type}} bind:value={pw} {...rest} />
        <InputGroupText title={plaintext ? hidePwLabel : showPwLabel}>
            <button
                type="button"
                class="password-visibility-toggle"
                data-test-name="password-visibility-toggle"
                onclick={togglePwReveal}
            >
                <Fa icon={plaintext ? faEyeSlash : faEye} />
            </button>
        </InputGroupText>
        <FormFeedback class="feedback">{formFeedback}</FormFeedback>
    </InputGroup>
</div>

<style>
    :global(.input-password .feedback) {
        text-align: left;
        display: block;
        visibility: hidden;
    }

    :global(.input-password .is-invalid~.invalid-feedback) {
        visibility: initial;
    }

    :global(.input-password input, .input-password input:focus) {
        background-color: var(--brak-greyed-white);
    }

    .password-visibility-toggle {
        border: none;
        background-color: var(--bs-color-bg);
    }
</style>
